import { http } from '@/utils/HttpClient';
import endpoints from '@/endpoints';
import { PaddleEventData } from '@paddle/paddle-js';
import { Plan } from '@/features/subscription/types/plan';
import { PaddleSubscription } from '../types/paddle';

export const checkoutService = {
  async complete(event: PaddleEventData): Promise<{
    message: string;
    planData: Plan;
    subscriptionData: any;
  }> {
    const response = await http.fetch({
      method: endpoints.paddle.checkout.completed.method,
      endpoint: endpoints.paddle.checkout.completed.url(),
      config: {
        body: event,
      },
    });

    if (response.status === 200) {
      return response.data as {
        message: string;
        planData: Plan;
        subscriptionData: any;
      };
    } else {
      throw new Error(`Failed to complete checkout: ${response.status}`);
    }
  },
};
